import _ from "lodash";
import update from "immutability-helper";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import {
  goToRelativeRoute,
  setProgress,
  removeProgressElement,
  downloadFromUrl,
} from "modules/Services";
import { getPrintFile } from "modules/PrintThunks";
import {
  updateStudentAssessmentEvaluationMutation,
  createAssessmentEvaluationMutation,
  deleteAssessmentEvaluationMutation,
  handleAssessmentToolResponseMutation,
  updateAssessmentEvaluationMutation,
} from "./AssessmentEvaluationMutation";
import { createIbPypElementRatingsMutation } from "ClassRoom/modules/ClassRoomMutation";
import {
  getStudentAssessmentEvaluationFromCache,
  writeStudentAssessmentEvaluationInCache,
  getCourseAssessmentEvaluationFeedFromCache,
  writeCourseAssessmentEvaluationFeed,
  getCourseAssessmentEvaluationCountFromCache,
  writeCourseAssessmentEvaluationCount,
} from "./AssessmentEvaluationGraphqlHelpers";
import {
  createIBPYPElementRatingsMutation,
  deleteMultipleIBPYPElementRatingsMutation,
} from "modules/CommonMutations";
import { createPost } from "Post/modules/PostModule";
import client from "lib/apolloClient/client";
import { generateRandomId } from "Utils";
import {
  getStudentAssignmentDetailsFromCache,
  writeStudentAssignmentDetailsInCache,
  getStudentAssignmentSubmissionFromCache,
  writeStudentAssignmentSubmissionInCache,
} from "ClassRoom/modules/ClassRoomGraphqlHelpers";
import {
  getAssessedDataForProjectFromCache,
  getIndividualAssessmentDataForProjectFromCache,
  writeAssessedDataForProjectInCache,
  writeIndividualAssessedDataForProjectInCache,
} from "Projects/routes/ProjectDetails/routes/Assessment/modules/GraphqlHelpers";
import {
  getPPGradebookProjectGroupStudentsWithProjectsFromCache,
  writePPGradebookProjectGroupStudentsWithProjectsToCache,
} from "ProjectsGradebook/routes/Assessment/components/PPGradebookTable/modules/PPGradebookTableGraphqlHelpers";
import {
  getCPGradebookProjectGroupProjectsFromCache,
  writeCPGradebookProjectGroupProjectsInCache,
  writeCPGradebookProjectGroupProjectsWithStudentCollaboratorsInCache,
  getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache,
} from "ProjectsGradebook/routes/Assessment/components/CPGradebookTable/modules/CPGradebookTableGraphqlHelpers";
import {
  getOrganizationAssignmentsProgressSummaryFromCache,
  writeOrganizationAssignmentsInCache,
} from "ProgressSummary/modules/ProgressSummaryGraphqlHelpers";
import { getOrgProgressSummaryVariables } from "AppComponents/ProgressSummary/modules/Utils";
import {
  getQuestionSubmissionFromCache,
  writeQuestionSubmissionInCache,
  getStudentAssignmentDetailsForScorebookFromCache,
  writeStudentAssignmentDetailsForScorebookInCache,
} from "Worksheet/modules/WorksheetGraphqlHelpers";
import { QUESTION_SUBMISSION } from "Worksheet/modules/WorksheetConstants";
import ACLStore from "lib/aclStore";
import { getSelectedAcademicYearId } from "modules/CommonSelectors";
import {
  PROJECT_GRADEBOOK,
  PROJECT_GROUP_TYPE_PERSONAL,
  PROJECT_GROUP_TYPE_COMMUNITY,
} from "Projects/Constants/stringConstants";

export const NAME = "assessmentEvaluation";

export const UPDATE_ASSESSMENT_FILTERS =
  "UPDATE_ASSESSMENT_FILTERS" + " " + NAME;
export const UPDATE_STATE = "UPDATE_STATE" + " " + NAME;
export const INIT_ASSESSMENT_FILTERS = "INIT_ASSESSMENT_FILTERS" + " " + NAME;
export const UPDATE_RESOURCE_ITEMS = "UPDATE_RESOURCE_ITEMS" + " " + NAME;

export const updateAssessmentFilters = data => {
  return {
    type: UPDATE_ASSESSMENT_FILTERS,
    data,
  };
};

export const initAssessmentFilters = () => {
  return {
    type: INIT_ASSESSMENT_FILTERS,
  };
};

export const updateResourceItems = data => {
  return {
    type: UPDATE_RESOURCE_ITEMS,
    data,
  };
};

export const updateState = data => {
  return {
    type: UPDATE_STATE,
    data,
  };
};

export const updateRemark = ({ id, value }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    try {
      const result = await client.mutate({
        mutation: updateStudentAssessmentEvaluationMutation,
        variables: {
          id,
          updatedBy: userInfo.id,
          remark: value,
        },
      });
    } catch (e) {
      //console.log(e);
    }
  };
};

export const updateSubmittedByStudent = ({ id, value = false } = {}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const studentEvaluationDetails = getStudentAssessmentEvaluationFromCache({
      studentEvaluationId: id,
    });
    const updatedStudentEvaluationDetails = {
      ...studentEvaluationDetails,
      submittedByStudent: value,
    };
    writeStudentAssessmentEvaluationInCache({
      studentEvaluationId: id,
      data: updatedStudentEvaluationDetails,
    });
    try {
      await client.mutate({
        mutation: updateStudentAssessmentEvaluationMutation,
        variables: {
          id,
          updatedBy: userInfo.id,
          submittedByStudent: value,
        },
      });
    } catch (e) {
      writeStudentAssessmentEvaluationInCache({
        studentEvaluationId: id,
        data: studentEvaluationDetails,
      });
      //console.log(e);
    }
  };
};

export const toggleStudentAssessmentEvaluation = ({
  id,
  isEnable,
  addedStudents = [],
  removedStudents = [],
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    try {
      const result = await client.mutate({
        mutation: updateAssessmentEvaluationMutation,
        variables: {
          id,
          updatedBy: userInfo.id,
          isEvaluatedByStudent: isEnable,
          removedStudents,
          addedStudents,
        },
      });
    } catch (e) {
      //console.log(e);
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }

      throw e;
    }
  };
};

export const updateRemarkInLocal = ({ id, value }) => {
  return async (dispatch, getState) => {
    const studentAssessmentEvaluation = getStudentAssessmentEvaluationFromCache(
      {
        studentEvaluationId: id,
      }
    );
    writeStudentAssessmentEvaluationInCache({
      studentEvaluationId: id,
      data: { ...studentAssessmentEvaluation, remark: value },
    });
  };
};

export const changeSelectedStudent = ({ id, currentId }) => {
  return (dispatch, getState) => {
    dispatch(
      goToRelativeRoute({
        route: id,
        type: "replace",
        replacePath: currentId,
      })
    );
  };
};

export const goToInsight = ({ id }) => {
  return (dispatch, getState) => {
    dispatch(
      goToRelativeRoute({ route: `insight`, type: "push", replacePath: id })
    );
  };
};

export const goBackToStudentEvaluationDetails = ({ id }) => {
  return (dispatch, getState) => {
    dispatch(goToRelativeRoute({ route: `../`, type: "replace" }));
  };
};

export const backToEvaluationDetails = () => {
  return (dispatch, getState) => {
    dispatch(goToRelativeRoute({ route: `..`, type: "replace" }));
  };
};

export const goToEvaluationDetails = id => {
  return (dispatch, getState) => {
    dispatch(goToRelativeRoute({ route: `${id}` }));
  };
};

export const downloadEvaluation = ({ ids, fileName }) => {
  return async (dispatch, getState) => {
    const uploadId = generateRandomId();
    const attachment = {
      type: "FILE",
      url: ``,
      mimeType: "application/pdf",
      name: fileName,
    };
    setTimeout(() => {
      dispatch(
        setProgress({ id: uploadId, attachment: attachment, status: "SAVE" })
      );
    });
    const fileUrl = await dispatch(
      getPrintFile({
        id: _.join(ids, ","),
        type: "assessmentevaluation",
        shouldOpenInWindow: false,
      })
    );
    if (fileUrl) {
      dispatch(
        downloadFromUrl({
          fileUploadId: uploadId,
          attachment: {
            ...attachment,
            url: fileUrl,
          },
          shouldAskForSave: true,
        })
      );
    }
    dispatch(setProgress({ id: uploadId, status: "DONE" }));
    setTimeout(() => {
      dispatch(removeProgressElement({ id: uploadId }));
    }, 3000);
  };
};

export const publishEvaluation = ({ evaluationData = [] }) => {
  return async (dispatch, getState) => {
    const courseId = getState().teacher.selected_class.selected_course;
    _.map(evaluationData, async item => {
      const {
        studentEvaluationId,
        studentId,
        assessmentId,
        unitPlanId,
        firstName,
        url = "",
      } = item;
      const uploadId = generateRandomId();
      const attachment = {
        type: "FILE",
        url: url,
        mimeType: "application/pdf",
        name: `${firstName}'s Assessment Evaluation`,
      };
      try {
        setTimeout(() => {
          dispatch(
            setProgress({
              id: uploadId,
              attachment: attachment,
              status: "SAVE",
            })
          );
        });

        const fileUrl = url
          ? url
          : await dispatch(
              getPrintFile({
                type: "assessmentevaluation",
                id: studentEvaluationId,
                shouldOpenInWindow: false,
                throwErrorEnabled: true,
              })
            );
        if (!fileUrl) {
          return;
        }

        const postDetails = {
          title: "",
          attachments: [
            {
              ...attachment,
              url: fileUrl,
            },
          ],
          students: { edges: [{ node: { id: studentId } }] },
          unitPlan: { id: unitPlanId },
          resourceItem: { id: assessmentId },
          resourceType: "ASSESSMENT",
          elementPYP: undefined,
          state: "PUBLISHED",
          isPrivate: false,
          courseId,
        };

        await dispatch(createPost({ postDetails, fromJournal: false }));
        dispatch(setProgress({ id: uploadId, status: "DONE" }));
        setTimeout(() => {
          dispatch(removeProgressElement({ id: uploadId }));
        }, 3000);
      } catch {
        setTimeout(() => {
          dispatch(removeProgressElement({ id: uploadId }));
        }, 3000);
      }
    });
  };
};
export const toggleStudentCompletedStatus = ({ id, isComplete }, callback) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const studentEvaluationDetails = getStudentAssessmentEvaluationFromCache({
      studentEvaluationId: id,
    });
    const updatedStudentEvaluationDetails = {
      ...studentEvaluationDetails,
      isComplete,
    };
    let isActive;
    if (!isComplete) {
      isActive = true;
      updatedStudentEvaluationDetails["isActive"] = true;
    }

    writeStudentAssessmentEvaluationInCache({
      studentEvaluationId: id,
      data: updatedStudentEvaluationDetails,
    });
    try {
      await client.mutate({
        mutation: updateStudentAssessmentEvaluationMutation,
        variables: {
          id,
          isComplete,
          isActive,
          updatedBy: userInfo.id,
        },
      });
    } catch (error) {
      callback({ id });
      writeStudentAssessmentEvaluationInCache({
        studentEvaluationId: id,
        data: studentEvaluationDetails,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const toggleStudentActiveStatus = ({ id, isActive }, callback) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const studentEvaluationDetails = getStudentAssessmentEvaluationFromCache({
      studentEvaluationId: id,
    });
    const updatedStudentEvaluationDetails = {
      ...studentEvaluationDetails,
      isActive,
    };
    const isComplete = !isActive;
    updatedStudentEvaluationDetails["isComplete"] = isComplete;
    updatedStudentEvaluationDetails["isActive"] = isActive;

    writeStudentAssessmentEvaluationInCache({
      studentEvaluationId: id,
      data: updatedStudentEvaluationDetails,
    });

    try {
      await client.mutate({
        mutation: updateStudentAssessmentEvaluationMutation,
        variables: {
          id,
          isComplete,
          isActive,
          updatedBy: userInfo.id,
        },
      });
    } catch (error) {
      callback({ id });
      writeStudentAssessmentEvaluationInCache({
        studentEvaluationId: id,
        data: studentEvaluationDetails,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const toggleStudentPypEvaluateStatus = ({
  id,
  evaluateIBPYPElements,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const studentEvaluationDetails = getStudentAssessmentEvaluationFromCache({
      studentEvaluationId: id,
    });

    const updatedStudentEvaluationDetails = {
      ...studentEvaluationDetails,
      evaluateIBPYPElements,
    };
    if (!evaluateIBPYPElements) {
      updatedStudentEvaluationDetails["ibPYPElementRatings"] = [];
    }
    writeStudentAssessmentEvaluationInCache({
      studentEvaluationId: id,
      data: updatedStudentEvaluationDetails,
    });

    try {
      await client.mutate({
        mutation: updateStudentAssessmentEvaluationMutation,
        variables: {
          id,
          evaluateIBPYPElements,
          updatedBy: userInfo.id,
        },
      });
    } catch (error) {
      writeStudentAssessmentEvaluationInCache({
        studentEvaluationId: id,
        data: studentEvaluationDetails,
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const getAssessmentFilter = ({ filter, userId }) => {
  const { user, status, units, searchText } = filter;
  return {
    unitPlanIds: units != "ALL" ? units : undefined,
    state: status,
    userIds: user == "MY" ? userId : undefined,
    searchText,
  };
};

export const deleteAssessmentEvaluation = evalutationId => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const courseId = getState().teacher.selected_class.selected_course;
    const userId = userInfo.id;
    const assessmentFilters = getState().assessmentEvaluation.assessmentFilters;
    const courseDetails = getCourseAssessmentEvaluationFeedFromCache({
      courseId,
      ...getAssessmentFilter({ filter: assessmentFilters, userId }),
    });

    const assessmentEvaluationCount = getCourseAssessmentEvaluationCountFromCache(
      {
        courseId,
      }
    );

    try {
      await client.mutate({
        mutation: deleteAssessmentEvaluationMutation,
        variables: {
          id: evalutationId,
          deletedBy: userId,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            deleteAssessmentEvaluation: true,
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { deleteAssessmentEvaluation },
            },
          }
        ) => {
          if (deleteAssessmentEvaluation) {
            const assessmentEvaluations = _.get(
              courseDetails,
              "assessmentEvaluations",
              {}
            );
            const evaluationEdges = _.filter(
              _.get(assessmentEvaluations, "edges", []),
              item => item.node.id != evalutationId
            );

            const updatedCourseDetails = {
              ...courseDetails,
              assessmentEvaluations: {
                ...assessmentEvaluations,
                edges: evaluationEdges,
                totalCount: evaluationEdges.length,
              },
            };

            const updatedCount = {
              ...assessmentEvaluationCount,
              assessmentEvaluations: {
                ...assessmentEvaluationCount.assessmentEvaluations,
                totalCount:
                  _.get(
                    assessmentEvaluationCount,
                    `assessmentEvaluations.totalCount`,
                    0
                  ) - 1,
              },
            };

            setTimeout(() => {
              writeCourseAssessmentEvaluationFeed({
                courseId,
                ...getAssessmentFilter({ filter: assessmentFilters, userId }),
                data: updatedCourseDetails,
              });
              writeCourseAssessmentEvaluationCount({
                courseId,
                data: updatedCount,
              });
            });
          }
        },
      });
    } catch (err) {
      setTimeout(() => {
        writeCourseAssessmentEvaluationFeed({
          courseId,
          ...getAssessmentFilter({ filter: assessmentFilters, userId }),
          data: courseDetails,
        });
        writeCourseAssessmentEvaluationCount({
          courseId,
          data: assessmentEvaluationCount,
        });
      });
      if (err.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: err.message, notString: true }));
      }
    }
  };
};

export const createAssessmentEvaluation = () => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    dispatch(initAssessmentFilters());
    const courseId = getState().teacher.selected_class.selected_course;
    const userId = userInfo.id;
    const assessmentFilters = getState().assessmentEvaluation.assessmentFilters;

    const courseDetails = getCourseAssessmentEvaluationFeedFromCache({
      courseId,
      ...getAssessmentFilter({ filter: assessmentFilters, userId }),
    });

    const assessmentEvaluationCount = getCourseAssessmentEvaluationCountFromCache(
      {
        courseId,
      }
    );

    const assessmentId = _.isEmpty(
      getState().assessmentEvaluation.resourceItems.selectedAssessments
    )
      ? null
      : getState().assessmentEvaluation.resourceItems.selectedAssessments[0];

    const includedStudents = _.isEmpty(
      getState().assessmentEvaluation.resourceItems.includedStudents
    )
      ? null
      : getState().assessmentEvaluation.resourceItems.includedStudents;

    if (!assessmentId) {
      return;
    }

    try {
      await client.mutate({
        mutation: createAssessmentEvaluationMutation,
        variables: {
          assessmentId: assessmentId,
          includedStudents: includedStudents,
          courseId: courseId,
          createdBy: userId,
        },
        // optimisticResponse: {
        //   __typename: "Mutation",
        //   planner: {
        //     __typename: "PlannerMutations",
        //     createAssessmentToolResponse: {
        //       id: generateRandomId(),
        //       rowId,
        //       columnId,
        //       __typename: "AssessmentToolResponse"
        //     }
        //   }
        // },
        update: (
          cache,
          {
            data: {
              planner: { createAssessmentEvaluation },
            },
          }
        ) => {
          const assessmentEvaluations = _.get(
            courseDetails,
            "assessmentEvaluations",
            {}
          );
          let evaluationEdges = _.get(assessmentEvaluations, "edges", []);
          evaluationEdges = [
            {
              node: createAssessmentEvaluation,
              __typename: "AssessmentEvaluationEdge",
            },

            ...evaluationEdges,
          ];
          const totalCount = _.get(assessmentEvaluations, "totalCount", 0) + 1;
          const updatedCourseDetails = {
            ...courseDetails,
            assessmentEvaluations: {
              ...assessmentEvaluations,
              edges: evaluationEdges,
              totalCount,
            },
          };

          const updatedCount = {
            ...assessmentEvaluationCount,
            assessmentEvaluations: {
              ...assessmentEvaluationCount.assessmentEvaluations,
              totalCount:
                _.get(
                  assessmentEvaluationCount,
                  `assessmentEvaluations.totalCount`,
                  0
                ) + 1,
            },
          };

          setTimeout(() => {
            if (!_.isEmpty(courseDetails)) {
              writeCourseAssessmentEvaluationFeed({
                courseId,
                ...getAssessmentFilter({ filter: assessmentFilters, userId }),
                data: updatedCourseDetails,
              });
            }

            writeCourseAssessmentEvaluationCount({
              courseId,
              data: updatedCount,
            });
          });
        },
      });
    } catch (err) {
      setTimeout(() => {
        if (!_.isEmpty(courseDetails)) {
          writeCourseAssessmentEvaluationFeed({
            courseId,
            ...getAssessmentFilter({ filter: assessmentFilters, userId }),
            data: courseDetails,
          });
        }

        writeCourseAssessmentEvaluationCount({
          courseId,
          data: assessmentEvaluationCount,
        });
      });
      if (err.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        const graphQLErrors = _.get(err, `graphQLErrors`, []);

        if (
          !_.isEmpty(graphQLErrors) &&
          graphQLErrors[0].message == "DUP_OBJ"
        ) {
          dispatch(
            setToastMsg("toastMsgs:assessment_already_added_for_evaluation")
          );
        } else {
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
        }
      }

      throw err;
    }
  };
};

export const createPypElementRating = ({
  projectId,
  parentId,
  parentType,
  studentId,
  studentIds = [],
  studentEvaluationId,
  academicTermId,
  criteriaValue,
  type,
  id,
  setId,
  isPublished,
  subjectId,
  score,
  academicCriteriaValue: updatedAcademicCriteriaValue,
  criteriaSet,
  criteriaLabel,
  ibPYPElementRatingsLocal,
  setIBPYPElementRatingsLocal,
  sourceFrom,
  queryVars,
  projectGroupType,
  isAutoSaveDisabled,
}) => {
  if (studentIds.length == 0) {
    studentIds = [studentId];
  }
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearId = getSelectedAcademicYearId(getState());
    const userType = userInfo?.user_type;
    let assessmentToolEvaluationDetails;

    const academicCriteriaSet = !_.isEmpty(criteriaSet)
      ? {
          ...criteriaSet,
          __typename: "AcademicCriteriaSet",
        }
      : {
          id: setId,
          __typename: "AcademicCriteriaSet",
          label: "",
          academicCriteriaValues: [],
          grades: [],
          criteriaType: "",
        };

    const academicCriteriaValue = !_.isEmpty(updatedAcademicCriteriaValue)
      ? { ...updatedAcademicCriteriaValue, __typename: "AcademicCriteriaValue" }
      : {
          id: criteriaValue,
          label: criteriaLabel,
          abbreviation: "",
          description: "",
          color: "",
          __typename: "AcademicCriteriaValue",
        };

    let newPypElementRating = {
      id: generateRandomId(),
      ibPYPElementId: id,
      ibPYPElementType: type,
      value: null,
      academicCriteriaSet: academicCriteriaSet,
      academicCriteriaValue: academicCriteriaValue,
      __typename: "IBPYPElementRating",
    };

    /* disabled auto save for bulk grading, storing data in local state */
    if (isAutoSaveDisabled && _.isFunction(setIBPYPElementRatingsLocal)) {
      const ibPYPElementRatingsLocalData = _.get(
        ibPYPElementRatingsLocal,
        parentId,
        []
      );

      const updatedElementRatings = _.filter(
        ibPYPElementRatingsLocalData,
        rating =>
          !(
            _.get(rating, "ibPYPElementId") == id &&
            _.get(rating, "ibPYPElementType") == type &&
            _.get(rating, "academicCriteriaSet.id") == setId
          )
      );

      if (score) {
        newPypElementRating.value = score;
      }

      newPypElementRating.academicTermId = academicTermId;
      updatedElementRatings.push(newPypElementRating);

      setIBPYPElementRatingsLocal({
        ...ibPYPElementRatingsLocal,
        [parentId]: updatedElementRatings,
      });

      return;
    }

    const isWorksheetQuestionScore =
      _.isEqual(parentType, QUESTION_SUBMISSION) && _.isEqual(type, "SCORE");
    if (isWorksheetQuestionScore) {
      newPypElementRating = {
        ...newPypElementRating,
        value: score,
        ibPYPElementId: null,
        academicCriteriaSet: null,
        academicCriteriaValue: null,
      };
    }

    const elementRating = {
      parentId,
      parentType,
      academicCriteriaValueId: criteriaValue,
      academicCriteriaSetId: setId,
      ibPYPElementId: id,
      ibPYPElementType: type,
      createdBy: userInfo.id,
      isPublished,
      subjectId,
    };
    if (ACLStore.can("FeatureFlag:AttachTermIdWithRating")) {
      elementRating.academicTermId = academicTermId;
    }

    if (score) {
      elementRating.value = score;
    }

    if (_.includes(["CLASSROOM", "GRADEBOOK"], sourceFrom)) {
      elementRating.source = sourceFrom;
    }

    const elementRatings = [];
    _.map(studentIds, studentId => {
      elementRatings.push({
        studentId: studentId,
        ...elementRating,
      });
    });

    let individualAssessmentToolEvaluationDetailsForProject;

    try {
      await client.mutate({
        mutation: createIBPYPElementRatingsMutation,
        variables: {
          elementRatings,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            createIBPYPElementRatings: [newPypElementRating],
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { createIBPYPElementRatings },
            },
          }
        ) => {
          setTimeout(() => {
            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              assessmentToolEvaluationDetails = getStudentAssessmentEvaluationFromCache(
                {
                  studentEvaluationId: parentId,
                }
              );
            } else if (parentType == "PROJECT") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_PERSONAL:
                    {
                      const variables = _.get(
                        queryVars,
                        "getPPGradebookProjectGroupStudentsWithProjectsVars",
                        {}
                      );
                      const data = getPPGradebookProjectGroupStudentsWithProjectsFromCache(
                        variables
                      );

                      const projectToBeUpdated = _.find(
                        _.get(data, "projects.edges", []),
                        item => {
                          const studentDetails = _.get(
                            item,
                            "node.students.0",
                            []
                          );
                          return studentDetails.id == studentId;
                        }
                      );

                      assessmentToolEvaluationDetails = _.get(
                        projectToBeUpdated,
                        "node.students[0]"
                      );
                    }
                    break;
                  case PROJECT_GROUP_TYPE_COMMUNITY: {
                    const variables = _.get(
                      queryVars,
                      "getCPGradebookProjectGroupProjectsQueryVars",
                      {}
                    );
                    const data = getCPGradebookProjectGroupProjectsFromCache(
                      variables
                    );

                    assessmentToolEvaluationDetails = _.find(
                      _.get(data, "projects.edges", []),
                      item => {
                        return item.node.id == parentId;
                      }
                    )?.node;
                  }
                }
              } else {
                assessmentToolEvaluationDetails = getAssessedDataForProjectFromCache(
                  {
                    id: parentId,
                  }
                );
              }
              isPublished = true;
            } else if (parentType == "PROJECT_STUDENT_MAP") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_COMMUNITY: {
                    const variables = _.get(
                      queryVars,
                      "getCPGradebookProjectGroupProjectsQueryVars",
                      {}
                    );
                    const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
                      variables
                    );

                    _.find(data?.projects?.edges, item => {
                      return _.find(
                        item?.node?.studentCollaborators,
                        student => {
                          if (student.id == parentId) {
                            assessmentToolEvaluationDetails = student;
                          }
                        }
                      );
                    });
                  }
                }
              } else {
                individualAssessmentToolEvaluationDetailsForProject = getIndividualAssessmentDataForProjectFromCache(
                  {
                    id: projectId,
                    filters: { studentIds: [studentId] },
                  }
                );

                assessmentToolEvaluationDetails = _.get(
                  individualAssessmentToolEvaluationDetailsForProject,
                  "node.studentCollaborators.0",
                  {}
                );
              }
            } else if (parentType == QUESTION_SUBMISSION) {
              assessmentToolEvaluationDetails = getQuestionSubmissionFromCache({
                id: parentId,
                userFilter: userType == "staff" ? "ALL" : "SELF",
              });
            } else {
              assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache(
                {
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  userArchivedFilters: { academicYearId },
                }
              );
            }
            let pypElementRatings = _.get(
              assessmentToolEvaluationDetails,
              "ibPYPElementRatings",
              []
            );

            if (!_.isEmpty(ibPYPElementRatingsLocal)) {
              pypElementRatings = _.get(ibPYPElementRatingsLocal, parentId);
            }

            let updatedElementRatings = _.filter(
              pypElementRatings,
              rating =>
                !(
                  _.get(rating, "ibPYPElementId") == id &&
                  _.get(rating, "ibPYPElementType") == type &&
                  _.get(rating, "academicCriteriaSet.id") == setId
                )
            );

            updatedElementRatings = [
              ...updatedElementRatings,
              ...createIBPYPElementRatings,
            ];

            if (_.isFunction(setIBPYPElementRatingsLocal)) {
              setIBPYPElementRatingsLocal({
                ...ibPYPElementRatingsLocal,
                [parentId]: updatedElementRatings,
              });

              return;
            }

            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              writeStudentAssessmentEvaluationInCache({
                studentEvaluationId: parentId,
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
              });
            } else if (parentType == "PROJECT") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_COMMUNITY:
                    {
                      const variables = _.get(
                        queryVars,
                        "getCPGradebookProjectGroupProjectsQueryVars",
                        {}
                      );
                      const data = getCPGradebookProjectGroupProjectsFromCache(
                        variables
                      );

                      const indexOfProjectToBeUpdated = _.findIndex(
                        _.get(data, "projects.edges", []),
                        item => item?.node?.id == parentId
                      );

                      const updatedData = update(data, {
                        projects: {
                          edges: {
                            [indexOfProjectToBeUpdated]: {
                              node: {
                                ibPYPElementRatings: {
                                  $set: updatedElementRatings,
                                },
                              },
                            },
                          },
                        },
                      });

                      writeCPGradebookProjectGroupProjectsInCache({
                        variables,
                        data: updatedData,
                      });
                    }
                    break;
                  case PROJECT_GROUP_TYPE_PERSONAL: {
                    const variables = _.get(
                      queryVars,
                      "getPPGradebookProjectGroupStudentsWithProjectsVars",
                      {}
                    );
                    const data = getPPGradebookProjectGroupStudentsWithProjectsFromCache(
                      variables
                    );

                    const indexOfProjectToBeUpdated = _.findIndex(
                      _.get(data, "projects.edges", []),
                      item => {
                        const studentDetails = _.get(
                          item,
                          "node.students.0",
                          []
                        );
                        return studentDetails.id == studentId;
                      }
                    );

                    const updatedData = update(data, {
                      projects: {
                        edges: {
                          [indexOfProjectToBeUpdated]: {
                            node: {
                              students: {
                                0: {
                                  ibPYPElementRatings: {
                                    $set: updatedElementRatings,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });

                    writePPGradebookProjectGroupStudentsWithProjectsToCache({
                      variables,
                      data: updatedData,
                    });
                  }
                }
              } else {
                writeAssessedDataForProjectInCache({
                  variables: { id: parentId },
                  data: {
                    node: {
                      ...assessmentToolEvaluationDetails,
                      ibPYPElementRatings: updatedElementRatings,
                    },
                  },
                });
              }
            } else if (parentType == "PROJECT_STUDENT_MAP") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_COMMUNITY: {
                    const variables = _.get(
                      queryVars,
                      "getCPGradebookProjectGroupProjectsQueryVars",
                      {}
                    );
                    const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
                      variables
                    );

                    const {
                      indexOfProjectToBeUpdated,
                      indexOfStudentCollaboratorToBeUpdated,
                    } = _.reduce(
                      data?.projects?.edges,
                      (acc, item, index) => {
                        const indexOfStudentCollaboratorToBeUpdated = _.findIndex(
                          _.get(item, "node.studentCollaborators", []),
                          student => student.id == parentId
                        );
                        if (indexOfStudentCollaboratorToBeUpdated != -1) {
                          acc.indexOfProjectToBeUpdated = index;
                          acc.indexOfStudentCollaboratorToBeUpdated = indexOfStudentCollaboratorToBeUpdated;
                        }
                        return acc;
                      },
                      {
                        indexOfProjectToBeUpdated: -1,
                        indexOfStudentCollaboratorToBeUpdated: -1,
                      }
                    );

                    const updatedData = update(data, {
                      projects: {
                        edges: {
                          [indexOfProjectToBeUpdated]: {
                            node: {
                              studentCollaborators: {
                                [indexOfStudentCollaboratorToBeUpdated]: {
                                  ibPYPElementRatings: {
                                    $set: updatedElementRatings,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });

                    writeCPGradebookProjectGroupProjectsWithStudentCollaboratorsInCache(
                      {
                        variables,
                        data: updatedData,
                      }
                    );
                  }
                }
              } else {
                individualAssessmentToolEvaluationDetailsForProject = getIndividualAssessmentDataForProjectFromCache(
                  {
                    id: projectId,
                    filters: { studentIds: [studentId] },
                  }
                );

                const updatedData = update(
                  individualAssessmentToolEvaluationDetailsForProject,
                  {
                    node: {
                      studentCollaborators: {
                        0: {
                          ibPYPElementRatings: {
                            $set: updatedElementRatings,
                          },
                        },
                      },
                    },
                  }
                );

                writeIndividualAssessedDataForProjectInCache({
                  variables: {
                    id: projectId,
                    filters: { studentIds: [studentId] },
                  },
                  data: updatedData,
                });
              }
            } else if (parentType == QUESTION_SUBMISSION) {
              if (!_.isEmpty(assessmentToolEvaluationDetails)) {
                writeQuestionSubmissionInCache({
                  id: parentId,
                  data: {
                    ...assessmentToolEvaluationDetails,
                    ibPYPElementRatings: updatedElementRatings,
                  },
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                });
              }
            } else {
              writeStudentAssignmentDetailsInCache({
                id: parentId,
                showOnlySubmitted: false,
                userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
                entityEventsFilter: {
                  orderBy: "EVENT_TIME",
                  orderByDir: "ASC",
                },
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
                userArchivedFilters: { academicYearId },
              });
            }
          });
        },
      });
    } catch (error) {
      setTimeout(() => {
        if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
          writeStudentAssessmentEvaluationInCache({
            studentEvaluationId: parentId,
            data: assessmentToolEvaluationDetails,
          });
        } else if (parentType == "PROJECT") {
          writeAssessedDataForProjectInCache({
            variables: { id: parentId },
            data: {
              node: {
                ...assessmentToolEvaluationDetails,
              },
            },
          });
        } else if (parentType == "PROJECT_STUDENT_MAP") {
          writeIndividualAssessedDataForProjectInCache({
            variables: {
              id: projectId,
              filters: { studentIds: [studentId] },
            },
            data: individualAssessmentToolEvaluationDetailsForProject,
          });
        } else if (parentType == QUESTION_SUBMISSION) {
          if (!_.isEmpty(assessmentToolEvaluationDetails)) {
            writeQuestionSubmissionInCache({
              id: parentId,
              data: {
                ...assessmentToolEvaluationDetails,
              },
              userFilter: userType == "staff" ? "ALL" : "SELF",
            });
          }
        } else {
          writeStudentAssignmentDetailsInCache({
            id: parentId,
            showOnlySubmitted: false,
            userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
            entityEventsFilter: {
              orderBy: "EVENT_TIME",
              orderByDir: "ASC",
            },
            data: assessmentToolEvaluationDetails,
            userArchivedFilters: { academicYearId },
          });
        }
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const deletePypElementRating = ({
  studentIds = [],
  studentId,
  id,
  type,
  setId,
  parentType,
  parentId,
  projectId,
  ibPYPElementRatingsLocal,
  setIBPYPElementRatingsLocal,
  sourceFrom,
  queryVars,
  projectGroupType,
  academicTermId,
  isAutoSaveDisabled,
  skipCacheWrite = false,
}) => {
  const userInfo = getUserInfo();
  if (studentIds.length == 0) {
    studentIds = [studentId];
  }

  return async (dispatch, getState) => {
    let assessmentToolEvaluationDetails;
    let individualAssessmentDataForProject;

    const academicYearId = getSelectedAcademicYearId(getState());

    /* disabled auto save for bulk grading, storing data in local state */
    if (isAutoSaveDisabled && _.isFunction(setIBPYPElementRatingsLocal)) {
      const ibPYPElementRatingsLocalData = _.get(
        ibPYPElementRatingsLocal,
        parentId,
        []
      );

      const updatedElementRatings = _.filter(
        ibPYPElementRatingsLocalData,
        rating =>
          !(
            _.get(rating, "ibPYPElementId") == id &&
            _.get(rating, "ibPYPElementType") == type &&
            _.get(rating, "academicCriteriaSet.id") == setId
          )
      );

      setIBPYPElementRatingsLocal({
        ...ibPYPElementRatingsLocal,
        [parentId]: updatedElementRatings,
      });

      return;
    }

    if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
      assessmentToolEvaluationDetails = getStudentAssessmentEvaluationFromCache(
        {
          studentEvaluationId: parentId,
        }
      );
    } else if (parentType == "PROJECT") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_PERSONAL:
            {
              const variables = _.get(
                queryVars,
                "getPPGradebookProjectGroupStudentsWithProjectsVars",
                {}
              );
              const data = getPPGradebookProjectGroupStudentsWithProjectsFromCache(
                variables
              );

              const projectToBeUpdated = _.find(
                _.get(data, "projects.edges", []),
                item => {
                  const studentDetails = _.get(item, "node.students.0", []);
                  return studentDetails.id == studentId;
                }
              );

              assessmentToolEvaluationDetails = _.get(
                projectToBeUpdated,
                "node.students[0]"
              );
            }
            break;
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const variables = _.get(
              queryVars,
              "getCPGradebookProjectGroupProjectsQueryVars",
              {}
            );
            const data = getCPGradebookProjectGroupProjectsFromCache(variables);

            assessmentToolEvaluationDetails = _.find(
              _.get(data, "projects.edges", []),
              item => {
                return item?.node?.id == parentId;
              }
            )?.node;
          }
        }
      } else {
        assessmentToolEvaluationDetails = getAssessedDataForProjectFromCache({
          id: parentId,
        });
      }
    } else if (parentType == "PROJECT_STUDENT_MAP") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const variables = _.get(
              queryVars,
              "getCPGradebookProjectGroupProjectsQueryVars",
              {}
            );
            const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
              variables
            );

            _.find(data?.projects?.edges, item => {
              return _.find(item?.node?.studentCollaborators, student => {
                if (student.id == parentId) {
                  assessmentToolEvaluationDetails = student;
                }
              });
            });
          }
        }
      } else {
        individualAssessmentDataForProject = getIndividualAssessmentDataForProjectFromCache(
          {
            id: projectId,
            filters: { studentIds: [studentId] },
          }
        );

        assessmentToolEvaluationDetails = _.get(
          individualAssessmentDataForProject,
          "node.studentCollaborators.0",
          {}
        );
      }
    } else {
      assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache({
        id: parentId,
        showOnlySubmitted: false,
        userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
        entityEventsFilter: {
          orderBy: "EVENT_TIME",
          orderByDir: "ASC",
        },
        userArchivedFilters: { academicYearId },
      });
    }

    let pypElementRatings = _.get(
      assessmentToolEvaluationDetails,
      "ibPYPElementRatings",
      []
    );

    if (!_.isEmpty(ibPYPElementRatingsLocal)) {
      pypElementRatings = _.get(ibPYPElementRatingsLocal, parentId);
    }

    const input = {
      studentId,
      parentId,
      parentType,
      academicCriteriaSetId: setId,
      ibPYPElementId: id,
      ibPYPElementType: type,
    };

    if (academicTermId) {
      input.academicTermId = academicTermId;
    }

    const inputArray = [];

    _.map(studentIds, studentId => {
      inputArray.push({
        ...input,
        studentId: studentId,
      });
    });

    try {
      await client.mutate({
        mutation: deleteMultipleIBPYPElementRatingsMutation,
        variables: {
          input: inputArray,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            deleteIBPYPElementRatings: true,
            deleteMultipleIBPYPElementRatings: true,
          },
        },
        update: () => {
          if (skipCacheWrite) return;

          const updatedElementRatings = _.filter(
            pypElementRatings,
            rating =>
              !(
                rating.ibPYPElementId == id &&
                rating.ibPYPElementType == type &&
                rating.academicCriteriaSet?.id == setId &&
                rating?.creatorType !== "AI"
              )
          );

          setTimeout(() => {
            if (_.isFunction(setIBPYPElementRatingsLocal)) {
              setIBPYPElementRatingsLocal({
                ...ibPYPElementRatingsLocal,
                [parentId]: updatedElementRatings,
              });

              return;
            }

            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              writeStudentAssessmentEvaluationInCache({
                studentEvaluationId: parentId,
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
              });
            } else if (parentType == "PROJECT") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_PERSONAL:
                    {
                      const variables = _.get(
                        queryVars,
                        "getPPGradebookProjectGroupStudentsWithProjectsVars",
                        {}
                      );
                      const data = getPPGradebookProjectGroupStudentsWithProjectsFromCache(
                        variables
                      );

                      const indexOfProjectToBeUpdated = _.findIndex(
                        _.get(data, "projects.edges", []),
                        item => {
                          const studentDetails = _.get(
                            item,
                            "node.students.0",
                            []
                          );
                          return studentDetails.id == studentId;
                        }
                      );

                      const updatedData = update(data, {
                        projects: {
                          edges: {
                            [indexOfProjectToBeUpdated]: {
                              node: {
                                students: {
                                  0: {
                                    ibPYPElementRatings: {
                                      $set: updatedElementRatings,
                                    },
                                  },
                                },
                              },
                            },
                          },
                        },
                      });

                      writePPGradebookProjectGroupStudentsWithProjectsToCache({
                        variables,
                        data: updatedData,
                      });
                    }
                    break;
                  case PROJECT_GROUP_TYPE_COMMUNITY: {
                    const variables = _.get(
                      queryVars,
                      "getCPGradebookProjectGroupProjectsQueryVars",
                      {}
                    );
                    const data = getCPGradebookProjectGroupProjectsFromCache(
                      variables
                    );

                    const indexOfProjectToBeUpdated = _.findIndex(
                      _.get(data, "projects.edges", []),
                      item => item?.node?.id == parentId
                    );

                    const updatedData = update(data, {
                      projects: {
                        edges: {
                          [indexOfProjectToBeUpdated]: {
                            node: {
                              ibPYPElementRatings: {
                                $set: updatedElementRatings,
                              },
                            },
                          },
                        },
                      },
                    });
                    writeCPGradebookProjectGroupProjectsInCache({
                      variables,
                      data: updatedData,
                    });
                  }
                }
              } else {
                writeAssessedDataForProjectInCache({
                  variables: { id: parentId },
                  data: {
                    node: {
                      ...assessmentToolEvaluationDetails,
                      ibPYPElementRatings: updatedElementRatings,
                    },
                  },
                });
              }
            } else if (parentType == "PROJECT_STUDENT_MAP") {
              if (sourceFrom == PROJECT_GRADEBOOK) {
                switch (projectGroupType) {
                  case PROJECT_GROUP_TYPE_COMMUNITY: {
                    const variables = _.get(
                      queryVars,
                      "getCPGradebookProjectGroupProjectsQueryVars",
                      {}
                    );
                    const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
                      variables
                    );

                    const {
                      indexOfProjectToBeUpdated,
                      indexOfStudentCollaboratorToBeUpdated,
                    } = _.reduce(
                      data?.projects?.edges,
                      (acc, item, index) => {
                        const indexOfStudentCollaboratorToBeUpdated = _.findIndex(
                          _.get(item, "node.studentCollaborators", []),
                          student => student.id == parentId
                        );
                        if (indexOfStudentCollaboratorToBeUpdated != -1) {
                          acc.indexOfProjectToBeUpdated = index;
                          acc.indexOfStudentCollaboratorToBeUpdated = indexOfStudentCollaboratorToBeUpdated;
                        }
                        return acc;
                      },
                      {
                        indexOfProjectToBeUpdated: -1,
                        indexOfStudentCollaboratorToBeUpdated: -1,
                      }
                    );

                    const updatedData = update(data, {
                      projects: {
                        edges: {
                          [indexOfProjectToBeUpdated]: {
                            node: {
                              studentCollaborators: {
                                [indexOfStudentCollaboratorToBeUpdated]: {
                                  ibPYPElementRatings: {
                                    $set: updatedElementRatings,
                                  },
                                },
                              },
                            },
                          },
                        },
                      },
                    });

                    writeCPGradebookProjectGroupProjectsWithStudentCollaboratorsInCache(
                      {
                        variables,
                        data: updatedData,
                      }
                    );
                  }
                }
              } else {
                const updatedData = update(individualAssessmentDataForProject, {
                  node: {
                    studentCollaborators: {
                      0: {
                        ibPYPElementRatings: {
                          $set: updatedElementRatings,
                        },
                      },
                    },
                  },
                });

                writeIndividualAssessedDataForProjectInCache({
                  variables: {
                    id: projectId,
                    filters: { studentIds: [studentId] },
                  },
                  data: updatedData,
                });
              }
            } else {
              writeStudentAssignmentDetailsInCache({
                id: parentId,
                showOnlySubmitted: false,
                userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
                entityEventsFilter: {
                  orderBy: "EVENT_TIME",
                  orderByDir: "ASC",
                },
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
                userArchivedFilters: { academicYearId },
              });
            }
          });
        },
      });
    } catch (error) {
      setTimeout(() => {
        if (skipCacheWrite) return;
        if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
          writeStudentAssessmentEvaluationInCache({
            studentEvaluationId: parentId,
            data: {
              ...assessmentToolEvaluationDetails,
              ibPYPElementRatings: pypElementRatings,
            },
          });
        } else if (parentType == "PROJECT") {
          writeAssessedDataForProjectInCache({
            variables: { id: parentId },
            data: {
              node: {
                ...assessmentToolEvaluationDetails,
                ibPYPElementRatings: pypElementRatings,
              },
            },
          });
        } else if (parentType == "PROJECT_STUDENT_MAP") {
          const updatedData = update(individualAssessmentDataForProject, {
            node: {
              studentCollaborators: {
                0: {
                  ibPYPElementRatings: {
                    $set: pypElementRatings,
                  },
                },
              },
            },
          });

          writeIndividualAssessedDataForProjectInCache({
            variables: {
              id: projectId,
              filters: { studentIds: [studentId] },
            },
            data: updatedData,
          });
        } else {
          writeStudentAssignmentDetailsInCache({
            id: parentId,
            showOnlySubmitted: false,
            userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
            entityEventsFilter: {
              orderBy: "EVENT_TIME",
              orderByDir: "ASC",
            },
            data: {
              ...assessmentToolEvaluationDetails,
              ibPYPElementRatings: pypElementRatings,
            },
            userArchivedFilters: { academicYearId },
          });
        }
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const handleAssessmentToolResponse = ({
  parentId,
  parentType = "STUDENT_ASSESSMENT_EVALUATION",
  rowId,
  columnId,
  type,
  subjectiveResponse = "",
  assessmentToolId,
  toolResponsesDataLocal,
  setToolResponsesDataLocal,
  creatorType,
  sourceFrom,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    try {
      const userType = userInfo.user_type;
      const userEntityType = creatorType || userInfo.userEntityType;
      const academicYearId = getSelectedAcademicYearId(getState());
      await client.mutate({
        mutation: handleAssessmentToolResponseMutation,
        variables: {
          parentId,
          parentType,
          rowId,
          columnId,
          subjectiveResponse,
          studentAssessmentEvaluationId: 123, //remove later
          type,
          createdBy: userInfo.id,
          creatorType: userEntityType,
          assessmentToolId,
        },
        update: (
          cache,
          {
            data: {
              planner: { handleAssessmentToolResponse },
            },
          }
        ) => {
          if (handleAssessmentToolResponse) {
            let assessmentToolEvaluationDetails;
            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              assessmentToolEvaluationDetails = getStudentAssessmentEvaluationFromCache(
                {
                  studentEvaluationId: parentId,
                }
              );
            } else if (sourceFrom == "SCOREBOOK") {
              assessmentToolEvaluationDetails = getStudentAssignmentDetailsForScorebookFromCache(
                {
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  userArchivedFilters: { academicYearId },
                }
              );
            } else {
              assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache(
                {
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  userArchivedFilters: { academicYearId },
                }
              );
            }

            let toolResponses = _.get(
              assessmentToolEvaluationDetails,
              "toolResponses",
              []
            );

            if (!_.isEmpty(toolResponsesDataLocal)) {
              toolResponses = _.get(
                _.find(
                  _.get(toolResponsesDataLocal, parentId),
                  ({ toolId }) => toolId === assessmentToolId
                ),
                "toolResponses",
                []
              );
            }

            const currentResponse = _.find(
              toolResponses,
              response =>
                response.rowId == rowId &&
                response.columnId == columnId &&
                response.creatorType == userEntityType
            );

            if (currentResponse && _.includes(currentResponse.id, "NEW")) {
              let updatedToolResponses = _.filter(
                toolResponses,
                response =>
                  !(response.rowId == rowId && response.columnId == columnId) ||
                  response.creatorType != userEntityType
              );

              updatedToolResponses = [
                ...updatedToolResponses,
                { ...currentResponse, id: handleAssessmentToolResponse.id },
              ];

              if (!_.isEmpty(toolResponsesDataLocal)) {
                updatedToolResponses = _.map(
                  _.get(toolResponsesDataLocal, parentId),
                  toolResponse => {
                    const toolToBeUpdated =
                      toolResponse?.toolId === assessmentToolId;

                    if (toolToBeUpdated) {
                      return {
                        ...toolResponse,
                        toolResponses: updatedToolResponses,
                      };
                    } else {
                      return toolResponse;
                    }
                  }
                );
              }

              if (_.isFunction(setToolResponsesDataLocal)) {
                setToolResponsesDataLocal({
                  ...toolResponsesDataLocal,
                  parentId: updatedToolResponses,
                });

                return;
              }

              if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
                writeStudentAssessmentEvaluationInCache({
                  studentEvaluationId: parentId,
                  data: {
                    ...assessmentToolEvaluationDetails,
                    toolResponses: updatedToolResponses,
                  },
                });
              } else if (sourceFrom == "SCOREBOOK") {
                writeStudentAssignmentDetailsForScorebookInCache({
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  data: {
                    ...assessmentToolEvaluationDetails,
                    toolResponses: updatedToolResponses,
                  },
                  userArchivedFilters: { academicYearId },
                });
              } else {
                writeStudentAssignmentDetailsInCache({
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  data: {
                    ...assessmentToolEvaluationDetails,
                    toolResponses: updatedToolResponses,
                  },
                  userArchivedFilters: { academicYearId },
                });
              }
            }
          }
        },
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    }
  };
};

export const handleAssessmentToolResponseInCache = ({
  rowId,
  columnId,
  projectId,
  parentId,
  studentId,
  parentType,
  type,
  subjectiveResponse = "",
  assessmentToolId,
  isToolResponsesV2 = false,
  assignmentId,
  sourceFrom,
  courseId,
  queryVars = {},
  projectGroupType,
  submissionId = null,
  creatorType,
  justification,
  isDeleteAiRatings,
  isDeleteBothAIAndStaffRatings,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const userEntityType = creatorType || userInfo.userEntityType;
    const academicYearId = getSelectedAcademicYearId(getState());
    let assessmentToolEvaluationDetails;
    let toolResponsesData = null;

    if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
      assessmentToolEvaluationDetails = getStudentAssessmentEvaluationFromCache(
        {
          studentEvaluationId: parentId,
        }
      );

      toolResponsesData = _.get(
        assessmentToolEvaluationDetails,
        "toolResponses",
        []
      );
    } else if (parentType == "PROJECT") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_PERSONAL:
            {
              const variables = _.get(
                queryVars,
                "getPPGradebookProjectGroupStudentsWithProjectsVars",
                {}
              );
              assessmentToolEvaluationDetails = getPPGradebookProjectGroupStudentsWithProjectsFromCache(
                variables
              );

              const projectToBeUpdated = _.find(
                _.get(assessmentToolEvaluationDetails, "projects.edges", []),
                item => {
                  return item.node.id == parentId;
                }
              );

              toolResponsesData = _.get(
                projectToBeUpdated,
                "node.toolResponses",
                []
              );
            }
            break;
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const variables = _.get(
              queryVars,
              "getCPGradebookProjectGroupProjectsQueryVars",
              {}
            );
            assessmentToolEvaluationDetails = getCPGradebookProjectGroupProjectsFromCache(
              variables
            );

            const projectToBeUpdated = _.find(
              _.get(assessmentToolEvaluationDetails, "projects.edges", []),
              item => {
                return item?.node?.id == parentId;
              }
            );

            toolResponsesData = _.get(
              projectToBeUpdated,
              "node.toolResponses",
              []
            );
          }
        }
      } else {
        assessmentToolEvaluationDetails = getAssessedDataForProjectFromCache({
          id: parentId,
        });
        toolResponsesData = _.get(
          assessmentToolEvaluationDetails,
          "toolResponses",
          []
        );
      }
    } else if (parentType == "PROJECT_STUDENT_MAP") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const variables = _.get(
              queryVars,
              "getCPGradebookProjectGroupProjectsQueryVars",
              {}
            );
            const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
              variables
            );

            _.find(data?.projects?.edges, item => {
              return _.find(item?.node?.studentCollaborators, student => {
                if (student.id == parentId) {
                  assessmentToolEvaluationDetails = student;
                }
              });
            });
          }
        }
      } else {
        const data = getIndividualAssessmentDataForProjectFromCache({
          id: projectId,
          filters: { studentIds: [studentId] },
        });

        assessmentToolEvaluationDetails = _.get(
          data,
          "node.studentCollaborators.0",
          {}
        );
      }
      toolResponsesData = _.get(
        assessmentToolEvaluationDetails,
        "toolResponses",
        []
      );
    } else if (parentType == QUESTION_SUBMISSION) {
      assessmentToolEvaluationDetails = getQuestionSubmissionFromCache({
        id: parentId,
        userFilter: userType == "staff" ? "ALL" : "SELF",
      });
      toolResponsesData = _.get(
        assessmentToolEvaluationDetails,
        "toolResponses",
        []
      );
    } else if (sourceFrom == "SCOREBOOK") {
      if (_.isEmpty(submissionId)) {
        assessmentToolEvaluationDetails = getStudentAssignmentDetailsForScorebookFromCache(
          {
            id: parentId,
            showOnlySubmitted: false,
            userFilter: userType == "staff" ? "ALL" : "SELF",
            entityEventsFilter: {
              orderBy: "EVENT_TIME",
              orderByDir: "ASC",
            },
            userArchivedFilters: { academicYearId },
          }
        );
        toolResponsesData = _.get(
          assessmentToolEvaluationDetails,
          "toolResponses",
          []
        );
      } else {
        assessmentToolEvaluationDetails = getStudentAssignmentSubmissionFromCache(
          {
            id: submissionId,
            userFilter: "ALL",
          }
        );
        toolResponsesData = _.get(
          assessmentToolEvaluationDetails,
          "evaluations.toolResponses",
          []
        );
      }
    } else {
      if (_.isEmpty(submissionId)) {
        assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter: userType == "staff" ? "ALL" : "SELF",
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          userArchivedFilters: { academicYearId },
        });
        toolResponsesData = _.get(
          assessmentToolEvaluationDetails,
          "toolResponses",
          []
        );
      } else {
        assessmentToolEvaluationDetails = getStudentAssignmentSubmissionFromCache(
          {
            id: submissionId,
            userFilter: "ALL",
          }
        );
        toolResponsesData = _.get(
          assessmentToolEvaluationDetails,
          "evaluations.toolResponses",
          []
        );
      }
    }

    if (toolResponsesData == null) {
      toolResponsesData = _.get(
        assessmentToolEvaluationDetails,
        "toolResponses",
        []
      );
    }

    const updatedToolResponses = getUpdatedToolResponses({
      type,
      rowId,
      columnId,
      justification,
      userEntityType,
      assessmentToolId,
      subjectiveResponse,
      isToolResponsesV2,
      toolResponsesData,
      isDeleteAiRatings,
      isDeleteBothAIAndStaffRatings,
    });

    if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
      writeStudentAssessmentEvaluationInCache({
        studentEvaluationId: parentId,
        data: {
          ...assessmentToolEvaluationDetails,
          toolResponses: updatedToolResponses,
        },
      });
    } else if (parentType == "PROJECT") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_PERSONAL:
            {
              const indexOfProjectToBeUpdated = _.findIndex(
                _.get(assessmentToolEvaluationDetails, "projects.edges", []),
                item => {
                  return item?.node?.id == parentId;
                }
              );

              const updatedData = update(assessmentToolEvaluationDetails, {
                projects: {
                  edges: {
                    [indexOfProjectToBeUpdated]: {
                      node: {
                        toolResponses: {
                          $set: updatedToolResponses,
                        },
                      },
                    },
                  },
                },
              });

              writePPGradebookProjectGroupStudentsWithProjectsToCache({
                variables: _.get(
                  queryVars,
                  "getPPGradebookProjectGroupStudentsWithProjectsVars",
                  {}
                ),
                data: updatedData,
              });
            }
            break;
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const indexOfProjectToBeUpdated = _.findIndex(
              _.get(assessmentToolEvaluationDetails, "projects.edges", []),
              item => {
                return item?.node?.id == parentId;
              }
            );

            const updatedData = update(assessmentToolEvaluationDetails, {
              projects: {
                edges: {
                  [indexOfProjectToBeUpdated]: {
                    node: {
                      toolResponses: {
                        $set: updatedToolResponses,
                      },
                    },
                  },
                },
              },
            });

            writeCPGradebookProjectGroupProjectsInCache({
              variables: _.get(
                queryVars,
                "getCPGradebookProjectGroupProjectsQueryVars",
                {}
              ),
              data: updatedData,
            });
          }
        }
      } else {
        writeAssessedDataForProjectInCache({
          variables: { id: parentId },
          data: {
            node: {
              ...assessmentToolEvaluationDetails,
              toolResponses: updatedToolResponses,
            },
          },
        });
      }
    } else if (parentType == "PROJECT_STUDENT_MAP") {
      if (sourceFrom == PROJECT_GRADEBOOK) {
        switch (projectGroupType) {
          case PROJECT_GROUP_TYPE_COMMUNITY: {
            const variables = _.get(
              queryVars,
              "getCPGradebookProjectGroupProjectsQueryVars",
              {}
            );
            const data = getCPGradebookProjectGroupProjectsWithStudentCollaboratorsFromCache(
              variables
            );

            const {
              indexOfProjectToBeUpdated,
              indexOfStudentCollaboratorToBeUpdated,
            } = _.reduce(
              data?.projects?.edges,
              (acc, item, index) => {
                const indexOfStudentCollaboratorToBeUpdated = _.findIndex(
                  _.get(item, "node.studentCollaborators", []),
                  student => student.id == parentId
                );
                if (indexOfStudentCollaboratorToBeUpdated != -1) {
                  acc.indexOfProjectToBeUpdated = index;
                  acc.indexOfStudentCollaboratorToBeUpdated = indexOfStudentCollaboratorToBeUpdated;
                }
                return acc;
              },
              {
                indexOfProjectToBeUpdated: -1,
                indexOfStudentCollaboratorToBeUpdated: -1,
              }
            );

            const updatedData = update(data, {
              projects: {
                edges: {
                  [indexOfProjectToBeUpdated]: {
                    node: {
                      studentCollaborators: {
                        [indexOfStudentCollaboratorToBeUpdated]: {
                          toolResponses: {
                            $set: updatedToolResponses,
                          },
                        },
                      },
                    },
                  },
                },
              },
            });

            writeCPGradebookProjectGroupProjectsWithStudentCollaboratorsInCache(
              {
                variables,
                data: updatedData,
              }
            );
          }
        }
      } else {
        const data = getIndividualAssessmentDataForProjectFromCache({
          id: projectId,
          filters: { studentIds: [studentId] },
        });

        const updatedData = update(data, {
          node: {
            studentCollaborators: {
              0: {
                toolResponses: {
                  $set: updatedToolResponses,
                },
              },
            },
          },
        });

        writeIndividualAssessedDataForProjectInCache({
          variables: {
            id: projectId,
            filters: { studentIds: [studentId] },
          },
          data: updatedData,
        });
      }
    } else if (parentType == QUESTION_SUBMISSION) {
      writeQuestionSubmissionInCache({
        id: parentId,
        data: {
          ...assessmentToolEvaluationDetails,
          toolResponses: updatedToolResponses,
        },
        userFilter: userType == "staff" ? "ALL" : "SELF",
      });
    } else if (sourceFrom == "SCOREBOOK") {
      if (_.isEmpty(submissionId)) {
        writeStudentAssignmentDetailsForScorebookInCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter: userType == "staff" ? "ALL" : "SELF",
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: {
            ...assessmentToolEvaluationDetails,
            toolResponses: updatedToolResponses,
          },
          userArchivedFilters: { academicYearId },
        });
      } else {
        writeStudentAssignmentSubmissionInCache({
          id: submissionId,
          userFilter: "ALL",
          data: {
            ...assessmentToolEvaluationDetails,
            evaluations: {
              ..._.get(assessmentToolEvaluationDetails, "evaluations", {}),
              toolResponses: updatedToolResponses,
            },
          },
        });
      }
    } else {
      if (_.isEmpty(submissionId)) {
        writeStudentAssignmentDetailsInCache({
          id: parentId,
          userFilter: userType == "staff" ? "ALL" : "SELF",
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: {
            ...assessmentToolEvaluationDetails,
            toolResponses: updatedToolResponses,
          },
          userArchivedFilters: { academicYearId },
        });
      } else {
        writeStudentAssignmentSubmissionInCache({
          id: submissionId,
          userFilter: "ALL",
          data: {
            ...assessmentToolEvaluationDetails,
            evaluations: {
              ..._.get(assessmentToolEvaluationDetails, "evaluations", {}),
              toolResponses: updatedToolResponses,
            },
          },
        });
      }
    }

    switch (sourceFrom) {
      case "CLASS_PROGRESS_SUMMARY": {
        const variables = getOrgProgressSummaryVariables({
          courseId,
          filters: _.get(getState(), "classProgressSummaryV2.filters", {}),
          organizationId: userInfo.org_id,
          curriculumType: _.get(
            getState(),
            "platform.currentCurriculumProgram.type"
          ),
        });

        const orgAssignments = getOrganizationAssignmentsProgressSummaryFromCache(
          variables
        );

        const edges = _.map(orgAssignments?.assignments?.edges, ({ node }) => {
          if (node?.id == assignmentId) {
            const assignedStudents = _.get(node, "assignedStudents", []);

            const updatedAssignedStudents = _.map(
              assignedStudents,
              assignedStudent => {
                if (assignedStudent?.id === parentId) {
                  return {
                    ...assignedStudent,
                    toolResponses: updatedToolResponses,
                  };
                }

                return assignedStudent;
              }
            );

            return {
              node: {
                ...node,
                assignedStudents: updatedAssignedStudents,
              },
              __typename: "AssignmentEdge",
            };
          }

          return { node, __typename: "AssignmentEdge" };
        });

        writeOrganizationAssignmentsInCache({
          variables,
          data: {
            id: userInfo.org_id,
            assignments: {
              edges,
              ..._.pick(orgAssignments?.assignments, ["pageInfo"]),
              __typename: "AssignmentConnection",
            },
            __typename: "Organization",
          },
        });
      }
    }
  };
};

const getDeletedAiToolResponses = ({
  type,
  rowId,
  columnId,
  toolResponses,
  subjectiveResponse,
}) => {
  if (type == "SINGLE_POINT_RUBRIC") {
    return _.map(toolResponses, response => {
      if (response.rowId === rowId && response.columnId === columnId) {
        if (response.creatorType === "AI") {
          return {
            ...response,
            isDeleted: true,
          };
        } else {
          return { ...response, subjectiveResponse };
        }
      }

      return response;
    });
  } else {
    return _.map(toolResponses, response => {
      if (response.rowId === rowId && response.creatorType === "AI") {
        return {
          ...response,
          isDeleted: true,
        };
      }

      return response;
    });
  }
};

export const getUpdatedToolResponses = ({
  type,
  rowId,
  columnId,
  justification = null,
  userEntityType,
  assessmentToolId,
  subjectiveResponse = "",
  isToolResponsesV2 = false,
  toolResponsesData,
  isDeleteAiRatings,
  isDeleteBothAIAndStaffRatings,
}) => {
  let toolResponses = [];

  if (isToolResponsesV2) {
    toolResponses = _.get(
      _.find(toolResponsesData, ({ toolId }) => toolId === assessmentToolId),
      "toolResponses",
      []
    );
  } else {
    toolResponses = toolResponsesData;
  }

  let updatedToolResponses = [];
  let id = null;
  if (type == "SINGLE_POINT_RUBRIC") {
    updatedToolResponses = _.filter(
      toolResponses,
      response =>
        !(response.rowId == rowId && response.columnId == columnId) ||
        response.creatorType != userEntityType
    );
    id = _.get(
      _.find(
        toolResponses,
        response =>
          response.rowId == rowId &&
          response.columnId == columnId &&
          response.creatorType == userEntityType
      ),
      "id",
      null
    );
  } else {
    updatedToolResponses = _.filter(
      toolResponses,
      response =>
        response.rowId != rowId ||
        (!isDeleteBothAIAndStaffRatings
          ? response.creatorType != userEntityType
          : false) // when inline evaluation is done, we need to delete both ai and staff ratings first and create a new ai rating
    );

    // if tool response already exist for the rowId and userEntityType
    // then we can retain the id
    id = _.get(
      _.find(
        toolResponses,
        response =>
          response.rowId == rowId && response.creatorType == userEntityType
      ),
      "id",
      null
    );
  }

  if (columnId) {
    const newResponse = {
      id: id || generateRandomId(),
      rowId,
      columnId,
      isDeleted: false,
      subjectiveResponse,
      creatorType: userEntityType,
      evaluationJustification: !_.isEmpty(justification)
        ? {
            id: generateRandomId(),
            message: justification,
            __typename: "IbPypElementRemark",
          }
        : null,
      __typename: "AssessmentToolResponse",
    };

    updatedToolResponses = [...updatedToolResponses, newResponse];
  }

  // soft delete ai ratings
  if (isDeleteAiRatings) {
    updatedToolResponses = getDeletedAiToolResponses({
      type,
      rowId,
      columnId,
      subjectiveResponse,
      toolResponses: updatedToolResponses,
    });
  }

  if (isToolResponsesV2) {
    updatedToolResponses = _.map(toolResponsesData, toolResponse => {
      const toolToBeUpdated = toolResponse?.toolId === assessmentToolId;

      if (toolToBeUpdated) {
        return {
          ...toolResponse,
          toolResponses: updatedToolResponses,
        };
      } else {
        return toolResponse;
      }
    });
  }

  return updatedToolResponses;
};

export const createDPRubricRatings = ({
  studentId,
  parentType,
  parentId,
  ibPYPElementType,
  academicCriteriaValueId,
  academicCriteriaSetId,
  ibPYPElementId,
  value,
  isPublished,
  academicTermId = null,
  ibPYPElementRatingsLocal,
  setIBPYPElementRatingsLocal,
  source,
  isDeleteAiRatings,
  isAutoSaveDisabled = false,
  isWorksheetScorebook = false,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const userFilter = userType == "staff" ? "ALL" : "SELF";
    const academicYearId = getSelectedAcademicYearId(getState());
    const createdBy = userInfo.id;

    const shouldAttachTermIdWithRating = ACLStore.can(
      "FeatureFlag:AttachTermIdWithRating"
    );

    let studentAssignmentDetails;

    if (!_.isEmpty(ibPYPElementRatingsLocal)) {
      studentAssignmentDetails = {
        ibPYPElementRatings: _.get(ibPYPElementRatingsLocal, parentId),
      };
    } else {
      if (parentType == QUESTION_SUBMISSION) {
        studentAssignmentDetails = getQuestionSubmissionFromCache({
          id: parentId,
          userFilter,
        });
      } else if (isWorksheetScorebook) {
        studentAssignmentDetails = getStudentAssignmentDetailsForScorebookFromCache(
          {
            id: parentId,
            showOnlySubmitted: false,
            userFilter,
            entityEventsFilter: {
              orderBy: "EVENT_TIME",
              orderByDir: "ASC",
            },
            userArchivedFilters: { academicYearId },
          }
        );
      } else {
        studentAssignmentDetails = getStudentAssignmentDetailsFromCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          userArchivedFilters: { academicYearId },
        });
      }
    }

    const ibPYPElementRatings =
      studentAssignmentDetails?.ibPYPElementRatings || [];

    const index =
      _.findIndex(ibPYPElementRatings, {
        ibPYPElementId,
        creatorType: isDeleteAiRatings ? "AI" : "STAFF",
      }) || _.findIndex(ibPYPElementRatings, { ibPYPElementId });

    let updatedData = {};

    if (!_.isEqual(index, -1)) {
      if (isDeleteAiRatings) {
        // 1. Mark AI rating as deleted
        const aiRating = ibPYPElementRatings[index];
        updatedData = update(studentAssignmentDetails, {
          ibPYPElementRatings: {
            [index]: {
              isDeleted: { $set: true },
            },
          },
        });

        // 2. Create a staff clone of the AI rating
        const staffRatingIndex = _.findIndex(ibPYPElementRatings, {
          ibPYPElementId,
          creatorType: "STAFF",
        });

        // if staff rating exist, then update the value
        // else create a new staff rating
        if (staffRatingIndex !== -1) {
          updatedData = update(updatedData, {
            ibPYPElementRatings: {
              [staffRatingIndex]: {
                value: { $set: value },
              },
            },
          });
        } else {
          const staffClone = {
            ...aiRating,
            id: generateRandomId(),
            creatorType: "STAFF",
            source: "STAFF",
            value,
          };

          // Add the staff clone to the array
          updatedData = update(updatedData, {
            ibPYPElementRatings: {
              $push: [staffClone],
            },
          });
        }
      } else {
        updatedData = update(studentAssignmentDetails, {
          ibPYPElementRatings: {
            [index]: {
              value: { $set: value },
            },
          },
        });
      }
    } else {
      const newIbPYPElementType = {
        id: generateRandomId(),
        value,
        ibPYPElementId,
        ibPYPElementType,
        academicCriteriaSet: null,
        academicCriteriaValue: null,
        source: null,
        isDeleted: false,
        creatorType: "STAFF",
        evaluationJustification: null,
        __typename: "IBPYPElementRating",
      };

      // * required academicTermId while performing bulk grading from gradebook
      if (isAutoSaveDisabled) {
        newIbPYPElementType.academicTermId = academicTermId;
      }

      updatedData = {
        ...studentAssignmentDetails,
        ibPYPElementRatings: [...ibPYPElementRatings, newIbPYPElementType],
      };
    }

    if (_.isFunction(setIBPYPElementRatingsLocal)) {
      const updatedIBPYPElementRatings = _.get(
        updatedData,
        "ibPYPElementRatings",
        []
      );

      setIBPYPElementRatingsLocal({
        ...ibPYPElementRatingsLocal,
        [parentId]: updatedIBPYPElementRatings,
      });

      // * handled for bulk grading
      if (isAutoSaveDisabled) return;
    } else {
      if (parentType == QUESTION_SUBMISSION) {
        writeQuestionSubmissionInCache({
          id: parentId,
          data: updatedData,
          userFilter,
        });
      } else {
        writeStudentAssignmentDetailsInCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: updatedData,
          userArchivedFilters: { academicYearId },
        });
      }
    }

    try {
      await client.mutate({
        mutation: createIBPYPElementRatingsMutation,
        variables: {
          elementRatings: {
            studentId,
            parentType,
            parentId,
            ibPYPElementType,
            academicCriteriaValueId,
            academicCriteriaSetId,
            ibPYPElementId,
            createdBy,
            value,
            isPublished,
            source,
            academicTermId: shouldAttachTermIdWithRating
              ? academicTermId
              : undefined,
          },
        },
      });
    } catch (e) {
      if (parentType == QUESTION_SUBMISSION) {
        if (!_.isEmpty(studentAssignmentDetails)) {
          writeQuestionSubmissionInCache({
            id: parentId,
            data: studentAssignmentDetails,
            userFilter,
          });
        }
      } else {
        writeStudentAssignmentDetailsInCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: studentAssignmentDetails,
          userArchivedFilters: { academicYearId },
        });
      }

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteDPRubricRatings = ({
  studentId,
  parentType,
  parentId,
  ibPYPElementType,
  ibPYPElementId,
  ibPYPElementRatingsLocal,
  setIBPYPElementRatingsLocal,
  academicTermId,
  isAutoSaveDisabled,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userType = userInfo.user_type;
    const academicYearId = getSelectedAcademicYearId(getState());
    const userFilter = userType == "staff" ? "ALL" : "SELF";

    let studentAssignmentDetails;

    if (!_.isEmpty(ibPYPElementRatingsLocal)) {
      studentAssignmentDetails = {
        ibPYPElementRatings: _.get(ibPYPElementRatingsLocal, parentId),
      };
    } else {
      if (parentType == QUESTION_SUBMISSION) {
        studentAssignmentDetails = getQuestionSubmissionFromCache({
          id: parentId,
          userFilter,
        });
      } else {
        studentAssignmentDetails = getStudentAssignmentDetailsFromCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          userArchivedFilters: { academicYearId },
        });
      }
    }

    const ibPYPElementRatings = studentAssignmentDetails?.ibPYPElementRatings;

    const index = _.findIndex(ibPYPElementRatings, {
      ibPYPElementId,
      creatorType: "STAFF",
    });

    const updatedData = update(studentAssignmentDetails, {
      ibPYPElementRatings: { $splice: [[index, 1]] },
    });

    if (_.isFunction(setIBPYPElementRatingsLocal)) {
      const updatedIBPYPElementRatings = _.get(
        updatedData,
        "ibPYPElementRatings"
      );

      setIBPYPElementRatingsLocal({
        ...ibPYPElementRatingsLocal,
        [parentId]: updatedIBPYPElementRatings,
      });

      // * handled for bulk grading
      if (isAutoSaveDisabled) return;
    } else {
      if (parentType == QUESTION_SUBMISSION) {
        writeQuestionSubmissionInCache({
          id: parentId,
          data: updatedData,
          userFilter,
        });
      } else {
        writeStudentAssignmentDetailsInCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: updatedData,
          userArchivedFilters: { academicYearId },
        });
      }
    }

    try {
      await client.mutate({
        mutation: deleteMultipleIBPYPElementRatingsMutation,
        variables: {
          input: {
            studentId,
            parentId,
            parentType,
            ibPYPElementType,
            ibPYPElementId,
            academicTermId,
          },
        },
      });
    } catch (e) {
      if (parentType == QUESTION_SUBMISSION) {
        if (!_.isEmpty(studentAssignmentDetails)) {
          writeQuestionSubmissionInCache({
            id: parentId,
            data: studentAssignmentDetails,
            userFilter,
          });
        }
      } else {
        writeStudentAssignmentDetailsInCache({
          id: parentId,
          showOnlySubmitted: false,
          userFilter,
          entityEventsFilter: {
            orderBy: "EVENT_TIME",
            orderByDir: "ASC",
          },
          data: studentAssignmentDetails,
          userArchivedFilters: { academicYearId },
        });
      }

      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createIbPypElementRating = ({
  parentId,
  parentType,
  studentId,
  studentIds = [],
  academicTermId,
  criteriaValue,
  type,
  id,
  setId,
  isPublished,
  subjectId,
  score,
  academicCriteriaValue: updatedAcademicCriteriaValue,
  criteriaSet,
  criteriaLabel,
  ibPYPElementRatingsLocal,
  setIBPYPElementRatingsLocal,
  sourceFrom,
  isDeleteAiRatings,
  isAutoSaveDisabled,
  learningCourseId,
  metadata,
  getIsMediaManagerRoute = () => {},
  setElementRatingMutationInProgress,
}) => {
  if (studentIds.length == 0) {
    studentIds = [studentId];
  }
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const academicYearId = getSelectedAcademicYearId(getState());
    const userType = userInfo?.user_type;
    let assessmentToolEvaluationDetails;

    // Only set mutation in progress flag for mediaManager page
    const isMediaManagerRoute = getIsMediaManagerRoute() || false;

    const academicCriteriaSet = !_.isEmpty(criteriaSet)
      ? {
          ...criteriaSet,
          __typename: "AcademicCriteriaSet",
        }
      : {
          id: setId,
          label: null,
          criteriaType: "",
          subType: null,
          isArchived: false,
          __typename: "AcademicCriteriaSet",
        };

    const academicCriteriaValue = !_.isEmpty(updatedAcademicCriteriaValue)
      ? { ...updatedAcademicCriteriaValue, __typename: "AcademicCriteriaValue" }
      : {
          id: criteriaValue || null,
          label: criteriaLabel || null,
          abbreviation: "",
          description: "",
          color: "",
          __typename: "AcademicCriteriaValue",
        };

    let newPypElementRating = {
      id: generateRandomId(),
      ibPYPElementId: id,
      ibPYPElementType: type,
      value: null,
      academicCriteriaSet: academicCriteriaSet,
      academicCriteriaValue: academicCriteriaValue,
      source: null,
      isDeleted: false,
      creatorType: "STAFF",
      evaluationJustification: null,
      subjectId,
      __typename: "IBPYPElementRating",
    };

    /* disabled auto save for bulk grading, storing data in local state */
    if (isAutoSaveDisabled && _.isFunction(setIBPYPElementRatingsLocal)) {
      const ibPYPElementRatingsLocalData = _.get(
        ibPYPElementRatingsLocal,
        parentId,
        []
      );

      const updatedElementRatings = _.filter(
        ibPYPElementRatingsLocalData,
        rating =>
          !(
            _.get(rating, "ibPYPElementId") == id &&
            _.get(rating, "ibPYPElementType") == type &&
            _.get(rating, "academicCriteriaSet.id") == setId
          )
      );

      if (score) {
        newPypElementRating.value = score;
      }

      if (learningCourseId) {
        newPypElementRating.learningCourseId = learningCourseId;
      }

      newPypElementRating.academicTermId = academicTermId;
      updatedElementRatings.push(newPypElementRating);

      setIBPYPElementRatingsLocal({
        ...ibPYPElementRatingsLocal,
        [parentId]: updatedElementRatings,
      });

      return;
    }

    const isWorksheetQuestionScore =
      _.isEqual(parentType, QUESTION_SUBMISSION) && _.isEqual(type, "SCORE");
    if (isWorksheetQuestionScore) {
      newPypElementRating = {
        ...newPypElementRating,
        value: score,
        ibPYPElementId: null,
        academicCriteriaSet: null,
        academicCriteriaValue: null,
      };
    }

    const elementRating = {
      parentId,
      parentType,
      academicCriteriaValueId: criteriaValue,
      academicCriteriaSetId: setId,
      ibPYPElementId: id,
      ibPYPElementType: type,
      createdBy: userInfo.id,
      isPublished,
      subjectId,
    };
    if (ACLStore.can("FeatureFlag:AttachTermIdWithRating")) {
      elementRating.academicTermId = academicTermId;
    }

    if (score) {
      elementRating.value = score;
    }

    if (_.includes(["CLASSROOM", "GRADEBOOK"], sourceFrom)) {
      elementRating.source = sourceFrom;
    }

    if (learningCourseId) {
      elementRating.learningCourseId = learningCourseId;
    }

    if (!_.isUndefined(metadata)) {
      elementRating.metadata = metadata;
    }

    const elementRatings = [];
    _.map(studentIds, studentId => {
      elementRatings.push({
        studentId: studentId,
        ...elementRating,
      });
    });

    try {
      if (
        isMediaManagerRoute &&
        !isAutoSaveDisabled &&
        setElementRatingMutationInProgress
      ) {
        dispatch(setElementRatingMutationInProgress(true));
      }
      await client.mutate({
        mutation: createIbPypElementRatingsMutation,
        variables: {
          elementRatings,
        },
        optimisticResponse: {
          __typename: "Mutation",
          planner: {
            __typename: "PlannerMutations",
            createIBPYPElementRatings: [newPypElementRating],
          },
        },
        update: (
          cache,
          {
            data: {
              planner: { createIBPYPElementRatings },
            },
          }
        ) => {
          setTimeout(() => {
            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              assessmentToolEvaluationDetails = getStudentAssessmentEvaluationFromCache(
                {
                  studentEvaluationId: parentId,
                }
              );
            } else if (parentType == QUESTION_SUBMISSION) {
              assessmentToolEvaluationDetails = getQuestionSubmissionFromCache({
                id: parentId,
                userFilter: userType == "staff" ? "ALL" : "SELF",
              });
            } else {
              assessmentToolEvaluationDetails = getStudentAssignmentDetailsFromCache(
                {
                  id: parentId,
                  showOnlySubmitted: false,
                  userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
                  entityEventsFilter: {
                    orderBy: "EVENT_TIME",
                    orderByDir: "ASC",
                  },
                  userArchivedFilters: { academicYearId },
                }
              );
            }
            let pypElementRatings = _.get(
              assessmentToolEvaluationDetails,
              "ibPYPElementRatings",
              []
            );

            if (!_.isEmpty(ibPYPElementRatingsLocal)) {
              pypElementRatings = _.get(ibPYPElementRatingsLocal, parentId);
            }

            let updatedElementRatings;

            // make isDeleted:true for AI in cache if isDeleteAiRatings is true,
            //  acceptAIResponseForAssessmentTools handles the bulk mutation to mutate it on backend
            if (isDeleteAiRatings) {
              let aiIBPYPElementRating;

              // 1. Mark AI rating as deleted
              updatedElementRatings = _.map(pypElementRatings, rating => {
                if (
                  _.get(rating, "ibPYPElementId") == id &&
                  _.get(rating, "ibPYPElementType") == type &&
                  _.get(rating, "creatorType") === "AI" &&
                  _.get(rating, "academicCriteriaSet.id") == setId &&
                  !rating?.isDeleted
                ) {
                  aiIBPYPElementRating = rating;

                  return {
                    ...rating,
                    isDeleted: true,
                  };
                }

                return rating;
              });

              // 2. update staff's response to AI's response
              updatedElementRatings = _.map(updatedElementRatings, rating => {
                const hasAIRatingForPYPElement =
                  _.get(rating, "ibPYPElementId") ===
                    _.get(aiIBPYPElementRating, "ibPYPElementId") &&
                  _.get(rating, "academicCriteriaSet.id") == setId;
                _.get(rating, "creatorType") === "STAFF";

                if (hasAIRatingForPYPElement) {
                  return {
                    ...rating,
                    academicCriteriaSet,
                    academicCriteriaValue,
                  };
                }

                return rating;
              });
            } else {
              updatedElementRatings = _.filter(
                pypElementRatings,
                rating =>
                  !(
                    _.get(rating, "ibPYPElementId") == id &&
                    _.get(rating, "ibPYPElementType") == type &&
                    _.get(rating, "academicCriteriaSet.id") == setId &&
                    _.get(rating, "creatorType", "STAFF") === "STAFF"
                  )
              );
            }

            updatedElementRatings = [
              ...updatedElementRatings,
              ...createIBPYPElementRatings,
            ];

            if (_.isFunction(setIBPYPElementRatingsLocal)) {
              setIBPYPElementRatingsLocal({
                ...ibPYPElementRatingsLocal,
                [parentId]: updatedElementRatings,
              });

              return;
            }

            if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
              writeStudentAssessmentEvaluationInCache({
                studentEvaluationId: parentId,
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
              });
            } else if (parentType == QUESTION_SUBMISSION) {
              if (!_.isEmpty(assessmentToolEvaluationDetails)) {
                writeQuestionSubmissionInCache({
                  id: parentId,
                  data: {
                    ...assessmentToolEvaluationDetails,
                    ibPYPElementRatings: updatedElementRatings,
                  },
                  userFilter: userType == "staff" ? "ALL" : "SELF",
                });
              }
            } else {
              writeStudentAssignmentDetailsInCache({
                id: parentId,
                showOnlySubmitted: false,
                userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
                entityEventsFilter: {
                  orderBy: "EVENT_TIME",
                  orderByDir: "ASC",
                },
                data: {
                  ...assessmentToolEvaluationDetails,
                  ibPYPElementRatings: updatedElementRatings,
                },
                userArchivedFilters: { academicYearId },
              });
            }
          });
        },
      });
    } catch (error) {
      setTimeout(() => {
        if (parentType == "STUDENT_ASSESSMENT_EVALUATION") {
          writeStudentAssessmentEvaluationInCache({
            studentEvaluationId: parentId,
            data: assessmentToolEvaluationDetails,
          });
        } else if (parentType == QUESTION_SUBMISSION) {
          if (!_.isEmpty(assessmentToolEvaluationDetails)) {
            writeQuestionSubmissionInCache({
              id: parentId,
              data: {
                ...assessmentToolEvaluationDetails,
              },
              userFilter: userType == "staff" ? "ALL" : "SELF",
            });
          }
        } else {
          writeStudentAssignmentDetailsInCache({
            id: parentId,
            showOnlySubmitted: false,
            userFilter: userInfo.user_type == "staff" ? "ALL" : "SELF",
            entityEventsFilter: {
              orderBy: "EVENT_TIME",
              orderByDir: "ASC",
            },
            data: assessmentToolEvaluationDetails,
            userArchivedFilters: { academicYearId },
          });
        }
      });
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg({ msg: error.message, notString: true }));
      }
    } finally {
      if (
        isMediaManagerRoute &&
        !isAutoSaveDisabled &&
        setElementRatingMutationInProgress
      ) {
        dispatch(setElementRatingMutationInProgress(false));
      }
    }
  };
};

// this does not write data to cache and takes array as an input
export const createIbPypElementRatingV2 = props => {
  const {
    elementRatings,
    getIsMediaManagerRoute = () => {},
    setElementRatingMutationInProgress,
  } = props;
  const isMediaManagerRoute = getIsMediaManagerRoute() || false;
  return async dispatch => {
    try {
      if (isMediaManagerRoute && setElementRatingMutationInProgress) {
        dispatch(setElementRatingMutationInProgress(true));
      }
      return await client.mutate({
        mutation: createIbPypElementRatingsMutation,
        variables: { elementRatings },
      });
    } catch (error) {
      if (error.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } finally {
      if (isMediaManagerRoute && setElementRatingMutationInProgress) {
        dispatch(setElementRatingMutationInProgress(false));
      }
    }
  };
};

const REDUCER_HANDLERS = {
  [INIT_ASSESSMENT_FILTERS]: (state, action) => {
    return update(state, {
      assessmentFilters: { $set: initialState.assessmentFilters },
    });
  },
  [UPDATE_RESOURCE_ITEMS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      resourceItems: { [key]: { $set: value } },
    });
  },
  [UPDATE_ASSESSMENT_FILTERS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      assessmentFilters: { [key]: { $set: value } },
    });
  },
  [UPDATE_STATE]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        [key]: { $set: params[key] },
      });
    });
    return state;
  },
};

const initialState = {
  assessmentFilters: {
    user: "ALL",
    status: "ALL",
    units: "ALL",
    searchText: "",
  },
  resourceItems: {},
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
